import { useMemo } from "react";

import { queryKeys } from "../queryKeys";
import {
  type ContraBroker,
  type GetListContraBrokersResponse,
  getListContraBrokers,
} from "../rest/acats";
import useRequest, { type QueryOptions } from "./useRequest";

// These are not self clearing, not returned by endpoint.
type DTCCNumber = "2402" | "0158";
const OPS_DTCC_MAPPING: Record<DTCCNumber, ContraBroker["name"][]> = {
  "2402": ["Racional", "InvestAll", "INDmoney Global (IFSC) Limited"],
  "0158": ["Webull"],
};

export const useGetAcatsContraBrokers = (
  options?: QueryOptions<GetListContraBrokersResponse>,
) => {
  const res = useRequest(
    queryKeys.acats.contraBrokers(),
    () => getListContraBrokers(),
    options,
  );

  const brokers: ContraBroker[] = useMemo(
    () =>
      // Do not merge with OPS_DTCC_MAPPING until API returns values
      res.data?.brokers
        ? [
            ...(res.data?.brokers ?? []),
            ...Object.entries(OPS_DTCC_MAPPING).flatMap(([dtccNumber, names]) =>
              names.map((name) => ({
                number: dtccNumber,
                name,
                type: "BROKER" as ContraBroker["type"],
              })),
            ),
          ]
        : [],
    [res.data?.brokers],
  );

  return {
    ...res,
    data: {
      brokers,
    },
  };
};
